// La Sala de Control dentro de la oficina (escritorio): su ventana en el mismo hueco que el chat (a la derecha del equipo,
// la oficina atenuada detrás). Las pantallas de la pared (ventas, cerebros y cuentas) son, desde el rebrand del
// 03-11, la fila de widgets de arriba de la oficina (FilaWidgets, la pinta el Escenario); al pulsarlas abren la sala.
// Se abre con ?sala=<pestaña> en la dirección (pulso, dinero, fans…): se puede enlazar a un rincón.
import { t } from '../../../i18n';
import { MARGEN_PX, useIzquierdaPx } from '../marco/Escenario';
import { PantallaCerebros } from './Cerebros';
import { PlacaCuentas } from '../cuentas/CuentasClaude';
import { PantallaPared } from './PantallaPared';
import { useSalaPulso } from './useSalaPulso';
import { PESTANAS, VentanaSala, type PestanaSala } from './VentanaSala';

export function CapaSala({ pestana, alCambiar }: { pestana: string | null; alCambiar: (p: PestanaSala | null) => void }) {
  const abierta = pestana !== null;
  const actual: PestanaSala = (PESTANAS as string[]).includes(pestana ?? '') ? (pestana as PestanaSala) : 'pulso';
  const alCerrar = () => alCambiar(null);
  const { pulso, fallo } = useSalaPulso();
  const izquierda = useIzquierdaPx();
  return (
    <>
      {abierta ? (
        <>
          <button type="button" tabIndex={-1} aria-label={t('salaControl.cerrar')} onClick={alCerrar} className="fixed inset-0 z-40 cursor-default bg-black/50 animate-in fade-in-0" />
          <div className="fixed z-40" style={{ left: izquierda, right: MARGEN_PX, top: MARGEN_PX, bottom: MARGEN_PX }}>
            <VentanaSala pulso={pulso} fallo={fallo} pestana={actual} alCambiarPestana={alCambiar} alCerrar={alCerrar} />
          </div>
        </>
      ) : null}
    </>
  );
}

/**
 * Las pantallas de la pared como widgets de Apple (ventas con la barra de cada hora, cerebros y cuentas de Claude), en su
 * franja arriba de la oficina de monigotes: una fila a todo lo ancho, ventas más ancha. Desde el 04-11 son la pared
 * misma (visual.md #3) y compactas, 64 px (orden.md regla 13). Santi sale de aquí: va a la lista (plan.md, «Lo que decide
 * Pau» 3; 0,6 usos al día); Cerebros se queda (Pau, 04-11). Solo existe con la oficina (escritorio e iPad), nunca en el
 * móvil. Si una no tiene datos, no ocupa sitio.
 */
export function FilaWidgets({ alCambiar }: { alCambiar: (p: PestanaSala | null) => void }) {
  const { pulso } = useSalaPulso();
  return (
    <div className="flex items-stretch gap-3 [&>*]:min-w-0 [&>*]:flex-1 [&>*:first-child]:shrink-0 [&>*:first-child]:grow-0 [&>*:first-child]:basis-2/5" data-testid="pantallas-pared">
      <PantallaPared pulso={pulso} alAbrir={() => alCambiar('pulso')} />
      <PantallaCerebros alAbrir={() => alCambiar('cerebros')} />
      <PlacaCuentas />
    </div>
  );
}
